module.exports = __webpack_public_path__ + "static/Math-5d32a44e3f7d47eb3fae70f435486010.png";